import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { buildUrl, OhifLaunchConfig } from './ohifviewer.utils';

@Component({
  selector: 'ohifviewer-dialog',
  template: `
    <button data-id="modal-close-button" mat-icon-button mat-dialog-close class="close-button">
      <mat-icon class="close-icon">close</mat-icon>
    </button>
    <div mat-dialog-content>
      <iframe [src]="viewerUrl" allow="cross-origin-isolated"></iframe>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      height: 100%;
      overflow: hidden;
      position: relative;
    }
    .close-button {
      color: #cccccc;
      position: absolute;
      right: 10px;
      top: 8px;
    }

    .close-icon {
      font-size: 32px;
    }

    iframe {
      border: none;
      height: 100%;
      width: 100%;
    }
    [mat-dialog-content] {
      border: none;
      height: 100%;
      margin: 0;
      max-height: none;
      overflow: hidden;
      padding: 0;
    }
  `],
})
export class OhifViewerDialog {
  public viewerUrl: SafeResourceUrl;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: OhifLaunchConfig,
    private sanitizer: DomSanitizer,
  ) {
    this.viewerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(buildUrl(data));
  }
}
